/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.com>
 */
import 'selectboxit/src/stylesheets/jquery.selectBoxIt.css';
import 'resources/less/themes/base/elements/simplified/dropdown.less';

import 'jquery-ui/ui/widget';
import 'selectboxit/src/javascripts/jquery.selectBoxIt';
